export const PREVIEW_STATE = {
  SHOW_OVERLAY: 'showOverlay',
  HIDE_OVERLAY: 'hideOverlay',
} as const;
